export const environment = {
    production: false,
    apiKeySAP: '4_vbDkFjHFklh6KI_Uxc6FPQ',
    bffBaseUrl: 'https://alia-multiutility-bff-926-staging.mashfrogcloud.com',
    apiKeyGmap: 'AIzaSyCFNqC95ec40ZNZhsV5lRVrMx1Bsqdj0TA',
    mapIdGoogle: 'DEMO_MAP_ID'
};
